<template>
  <ElInput ref="input" :type="type" v-bind="$attrs" v-on="$listeners">
    <template v-slot:suffix>
      <el-tooltip
        v-if="showRule"
        placement="top-start">
        <template v-slot:content>
          <div>密码长度不少于8个字符，并且包含以下四类字符中的三类字符:</div>
          <ul class="x-password-rule">
            <li>英文大写字母(A 到 Z)</li>
            <li>英文小写字母(a 到 z)</li>
            <li>10个基本数字(0 到 9)</li>
            <li>非字母字符(如 !、@、#、$、%、^、&、* 等等)</li>
          </ul>
        </template>
        <XIcon name="el-icon-warning-outline" class="x-login-password__view" :size="16" color="#F37D7D"></XIcon>
      </el-tooltip>
      <XIcon @click="toggle" :icon="icon" class="x-password-dialog__view" :size="16">
      </XIcon>
    </template>
  </ElInput>
</template>

<script>
import {Input as ElInput, Tooltip} from 'element-ui';
import Visible from '@/icon/Visible';
import Invisible from '@/icon/Invisible';

export default {
  inheritAttrs: false,
  components: {
    [Tooltip.name]: Tooltip,
    ElInput
  },
  props: {
    showRule: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    icon() {
      return this.visible ? Invisible : Visible;
    },
    type() {
      return this.visible ? 'text' : 'password';
    }
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    }
  }
};
</script>
